// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"af6ea6bd","224":"3f22fed6"}[chunkId] + ".chunk.js";
};